@let $results = resultsObservable | async;
@let $active = active();

<input
  type="search"
  #searchInput
  [placeholder]="placeholder()"
  [(ngModel)]="search"
  [class.text-danger]="$results?.length === 0"
  [class.flat-bottom]="$active"
  (keydown.arrowDown)="moveSelection(true)"
  (keydown.arrowUp)="moveSelection(false)"
  (keydown.enter)="selectResult()"
>

<ng-template #resultsTemplate>
  <div class="results rounded flat-top">
    <div class="app-column-auto">
      @if ($results && $results.length > 0) {
        @for (result of $results; track result.id) {
          <app-entity-card 
            [entity]="result" 
            class="result" 
            [class.selected]="$index === selectedIndex()"
            (click)="selectResult(result)"
          />
        }
      } @else if ($results?.length === 0) {
        <em class="no-results">No matching results.</em>
      } @else {
        <em class="no-results">Type to search...</em>
      }
    </div>
  </div>
</ng-template>
